import React from 'react'

import { Grid, Space } from '@gousto-internal/citrus-react'
import { HowGoustoFoodBoxesWorkTypes } from '../../../../types'
import { FoodBoxIntroduction } from './FoodBoxIntroduction'
import { MakeDinnerABreeze } from './MakeDinnerABreeze'
import { WhyGousto } from './WhyGousto'
import { OrderedCol } from './OrderedCol'
import { YouAreInControl } from './YouAreInControl'

export function WhatsFoodBox({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <Grid paddingV={16} paddingH={[4, 6, 14]}>
      <FoodBoxIntroduction />
      <OrderedCol order={3} size={12}>
        <Space size={12} />
      </OrderedCol>
      <MakeDinnerABreeze startOnboarding={startOnboarding} />
      <OrderedCol order={6} size={12}>
        <Space size={12} />
      </OrderedCol>
      <WhyGousto startOnboarding={startOnboarding} />
      <OrderedCol order={8} size={12}>
        <Space size={12} />
      </OrderedCol>
      <YouAreInControl startOnboarding={startOnboarding} />
    </Grid>
  )
}
